import React, { useContext, useRef, useEffect } from "react";
import { Context } from "../context";
// const YT = require("youtube-api")

export function DayEntry({ hours = 2, userId, comment, videoUrl, videoId }) {
  const context = useContext(Context);
  const hourLengthInEm = [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56];

  const draggable = useRef();

  useEffect(() => {



    // var player;

    // function onYouTubeIframeAPIReady() {
    //     player = new YT.Player('video-placeholder', {
    //         width: 600,
    //         height: 400,
    //         videoId: 'ifdLOWd05tM',
    //         playerVars: {
    //             color: 'white',
    //             playlist: 'ifdLOWd05tM'
    //         },
    //         events: {
    //             onReady: initialize
    //         }
    //     });
    // }

    // function initialize(){
    // }

    var selected = null, // Object of the element to be moved
    x_pos = 0, y_pos = 0, // Stores x & y coordinates of the mouse pointer
    x_elem = 0, y_elem = 0; // Stores top, left values (edge) of the element

// Will be called when user starts dragging an element
function _drag_init(elem) {
    // Store the object of the element which needs to be moved
    selected = elem;
    x_elem = x_pos - selected.offsetLeft;
    y_elem = y_pos - selected.offsetTop;
}

// Will be called when user dragging an element
function _move_elem(e) {
    //x_pos = document.all ? window.event.clientX : e.pageX;
    var parentTop = document.getElementById('draggable-element').parentElement.getBoundingClientRect().top + 20;
    var parentBot = document.getElementById('draggable-element').parentElement.getBoundingClientRect().bottom - 20;
    y_pos = document.all ? window.event.clientY : e.pageY;
    if (selected !== null &&
      parentTop < y_pos &&
      parentBot > y_pos
    ) {
        //selected.style.left = (x_pos - x_elem) + 'px';
        selected.style.top = (y_pos - y_elem) + 'px';

        // var newTime = ((y_pos - parentTop) / (parentBot - parentTop)) * player.getDuration();
        // console.log("parentTop = ", parentTop)
        // console.log("parentBot = ", parentBot)
        // console.log("y_pos = ", y_pos)
        // console.log("newTime = ", newTime)
      // Skip video to new time.
        // player.seekTo(newTime);

    }
}

// // Destroy the object when we are done
// function _destroy() {
//     selected = null;
// }

// // Bind the functions...
// document.getElementById('draggable-element').onmousedown = function () {
//     _drag_init(this);
//     return false;
// };

// document.onmousemove = _move_elem;
// document.onmouseup = _destroy;


  }, [])

  const user = context.handles.getUserDataById(userId);
  return (

      <div
        className="x_entry0"
        style={{ height: `${hourLengthInEm[hours + 1]}em` }}
      >
        <div ref={draggable} className="x_entry_ava"
          style={{ backgroundImage: `url(${user['img']})` }}
        >
          <div className="x_entry_preview0">
            <div className="x_entry_preview">
              <div className="x_entry_preview_open">
                <div className="x_entry_preview_open_icon">open_in_full</div>
              </div>
              <div className="x_entry_preview_t">
                <div className="x_entry_preview_name">
                  {user['name']}
                </div>
                <div className="x_entry_preview_message">{comment}</div>
              </div>

              <div className="x_entry_preview_embed0">
                <iframe
                  id="video-placeholder"
                  className="x_entry_preview_embed"
                  frameBorder={0}
                  allowFullScreen={1}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  title="YouTube video player"
                  width={600}
                  height={400}
                  src={`https://www.youtube.com/embed/${videoId}?color=white&playlist=${videoId}&enablejsapi=1&widgetid=1`} />
              </div>
            </div>
          </div>
        </div>
        <div className="x_entry_line x_entry_line--c2" />
      </div>

  );
}
